import { useCurrentUser } from '#src/app/shared/hooks/session';

import { useAddressFieldForAuthenticated } from '../useAddressFieldForAuthenticated';
import { useCurrentUserAddressIsComplete } from '../useCurrentUserAddressIsComplete';

export function useSingleAddressFieldForAuthenticated(): Result {
	const currentUser = useCurrentUser();

	const {
		data: { isComplete: currentUserAddressIsComplete },
	} = useCurrentUserAddressIsComplete(currentUser);

	return useAddressFieldForAuthenticated(!currentUserAddressIsComplete);
}

type Result = ModelHookResult<{
	enabled: boolean;
}>;
